import api from './api';

export type AIInstruction = {
  instruction_key: string;
  title: string;
  module: string;
  usage_tag: string;
  content: string;
  is_active: number;
  updated_by_user_id?: string | null;
  created_at?: string;
  updated_at?: string;
};

export async function getInstruction(key: string): Promise<AIInstruction | null> {
  try {
    const resp = await api.get(`/ai-instructions/${encodeURIComponent(key)}`);
    return resp.data?.success ? (resp.data.data as AIInstruction) : null;
  } catch (e: any) {
    // Jeśli brak rekordu, backend zwróci 404 – traktuj jako brak instrukcji
    if (e?.response?.status === 404) return null;
    throw e;
  }
}

export async function saveInstruction(key: string, payload: Partial<AIInstruction> & { content: string }) {
  const resp = await api.put(`/ai-instructions/${encodeURIComponent(key)}`, payload);
  return resp.data?.success ? (resp.data.data as AIInstruction) : null;
}


